import styled from "styled-components";

export type ButtonRowAlign = "center" | "end" | "between";

const JUSTIFY: Record<ButtonRowAlign, string> = {
  center: "center",
  end: "flex-end",
  between: "space-between",
};

// Buttons side by side: one gap for every footer, drawer, form and empty
// state, so no parent spaces its buttons with margins. The row wraps when it
// runs out of width. Where the buttons sit is the context's call.
const ButtonRow = styled.div<{ $align?: ButtonRowAlign }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${({ $align = "center" }) => JUSTIFY[$align]};
  gap: 12px;
`;

export default ButtonRow;
